import { jsx as _jsx } from "react/jsx-runtime";
export const TagV2 = ({ variant = "info", children, className = "", }) => {
    const getVariantClasses = () => {
        switch (variant) {
            case "active":
                // text-green-700
                return "bg-[#C8F1BB] text-[#132B0C]";
            case "inactive":
                // text-red-700
                return "bg-[#FDC0B9] text-[#3A0D08]";
            case "warning":
                // text-amber-700
                return "bg-amber-100";
            case "info":
                // text-blue-700
                return "bg-blue-100";
            case "neutral":
                return "bg-[#E2E6EA] text-gray-700";
            default:
                // text-gray-700
                return "bg-gray-100";
        }
    };
    return (_jsx("span", { className: `
        inline-block rounded-md px-2 py-1 text-xs font-medium
        ${getVariantClasses()}
        ${className}
      `, children: children }));
};
export default TagV2;
